import { ChallengeToolSet } from '@/src/components/tools/ChallengeToolSet';
import { useActiveRouteDetails } from '@/src/hooks/useActiveRouteDetails';
import { RoutePath } from '@/src/RoutePath';
import { useToolPanel } from '@/src/store/tool-panel.context';
import * as React from 'react';
import { ReactNode, useRef } from 'react';
import { tabbable } from 'tabbable';

export const ToolSets: React.FC = () => {
  const { toolPanelContent, toggleShowToolPanel } = useToolPanel();
  const { activeRoute } = useActiveRouteDetails();
  const toolRef = useRef<HTMLSpanElement>();

  const renderToolView = (): ReactNode => {
    switch (activeRoute) {
      case RoutePath.NEW_CHALLENGE:
        return <ChallengeToolSet />;
      default:
        // Hides the toolPanel if no route is assigning a tool panel
        toggleShowToolPanel(false);
        return null;
    }
  };

  React.useEffect(() => {
    if (!toolPanelContent) {
      return;
    }

    const toolsParent = toolRef.current?.closest('aside');

    if (!toolsParent) {
      return;
    }

    const elements = tabbable(toolsParent);

    if (!elements.length) {
      return;
    }

    elements[0].focus();
  }, [toolPanelContent]);

  if (toolPanelContent) {
    return (
      <React.Fragment>
        <span ref={toolRef as any} />
        {toolPanelContent}
      </React.Fragment>
    );
  }

  return <div>{renderToolView()}</div>;
};
